import React from 'react';
import { Grid, Box, Button, Modal, Fade, Typography } from '@mui/material';
import './AccountModal.css';
import { fonts, themes } from '../../themes/themes';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../infra/hooks';
import { user_logout } from '../../../infra/aggregates/authSlice';
import {
  resetCanClockIn,
  resetClockIn,
} from '../../../infra/aggregates/clockInSlice';
import { resetClockOut } from '../../../infra/aggregates/clockOutSlice';
import { resetMyTeam } from '../../../infra/aggregates/myTeamSlice';
import { resetPendingRequest } from '../../../infra/aggregates/pendingRequestSlice';
import { resetReportsTo } from '../../../infra/aggregates/reportsToSlice';
import { resetTimeline } from '../../../infra/aggregates/timelineSlice';
import { resetUpcomingBirthday } from '../../../infra/aggregates/upcomingBirthdaySlice';
import { resetBankInfo } from '../../../infra/aggregates/myProfile/bankInfoSlice';
import { resetJobInfo } from '../../../infra/aggregates/myProfile/jobInfoSlice';
import { resetEmergencyContact } from '../../../infra/aggregates/myProfile/emergencyContactSlice';
import { resetPersonalInfo } from '../../../infra/aggregates/myProfile/personalInfoSlice';
import logout_pic from '../../../assets/images/logout.svg';
import change_password from '../../../assets/images/change_password.svg';
import { resetLoading } from '../../../infra/aggregates/LoaderSlice';
import { resetUserProfilePic } from '../../../infra/aggregates/profilePicSlice';
import { changeApplang, logoutService } from '../../configs/utils';
import { useTranslation } from 'react-i18next';
import Compdirection from '../../themes/CompDirection';
import { resetLogOutBtn } from '../../../infra/aggregates/myProfile/isHRViewSlice';
import { remove_userRole } from '../../../infra/aggregates/UserRoleInfo';

interface ChildProps {
  isOpen: boolean; // try not to use any.
  onCloseModal: () => void;
  onOpenChangePassword: (data: boolean) => void;
}

const AccountModal: React.FC<ChildProps> = ({
  isOpen,
  onCloseModal,
  onOpenChangePassword,
}) => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const trans = t;
  const session_id = useAppSelector((state) => state?.authSlice?.user_session_id);
  
  const handleLogOut = async () => {
    const res = await logoutService(session_id);

    if (!res) return;

    localStorage.clear();
    dispatch(remove_userRole())
    dispatch(user_logout());
    dispatch(resetClockIn());
    dispatch(resetClockOut());
    dispatch(resetMyTeam());
    dispatch(resetPendingRequest());
    dispatch(resetReportsTo());
    dispatch(resetReportsTo());
    dispatch(resetTimeline());
    dispatch(resetUpcomingBirthday());
    dispatch(resetPersonalInfo());
    dispatch(resetJobInfo());
    dispatch(resetEmergencyContact());
    dispatch(resetBankInfo());
    dispatch(resetLoading());
    dispatch(resetUserProfilePic());
    dispatch(resetCanClockIn());
    dispatch(resetLogOutBtn());

    changeApplang('en', false);

    onCloseModal();

    navigate('/login');
  };

  return (
    <Compdirection>
      <Modal
        open={isOpen}
        disableAutoFocus
        closeAfterTransition
        onClose={() => onCloseModal()}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={isOpen}>
          <Box className={i18n.language == 'en' ? 'accmodal' : 'accmodal_rtl'}>
            <Grid container style={{ padding: '1em' }}>
              <Grid container className="logout">
                <Grid item xs={2}>
                  <img src={change_password} />
                </Grid>
                <Grid item xs={10}>
                  <Button
                    className="cancel-button"
                    fullWidth
                    onClick={() => onOpenChangePassword(true)}
                  >
                    <Typography
                      style={{
                        fontSize: fonts.title,
                        color: themes.blackDefault,
                        fontFamily: fonts.fontFamily,
                        textTransform: 'none',
                        letterSpacing: '0.5px',
                        display: 'flex',
                      }}
                    >
                      {trans('Change Password')}
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={12} className="change-password">
                <Grid item xs={2}>
                  <img src={logout_pic} />
                </Grid>

                <Grid item xs={10}>
                  <Button
                    className="cancel-button"
                    fullWidth
                    onClick={() => handleLogOut()}
                  >
                    <Typography
                      style={{
                        fontSize: fonts.title,
                        color: themes.blackDefault,
                        fontFamily: fonts.fontFamily,
                        textTransform: 'none',
                        letterSpacing: '0.5px',
                      }}
                    >
                      {trans('Logout')}
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </Compdirection>
  );
};

export default AccountModal;
